module.exports = __webpack_public_path__ + "static/media/iphone_13_pro_silver.350f8a08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_13_pro_silver.png
// module id = 2118
// module chunks = 0